import { Modal, Backdrop, Fade, Box } from "@mui/material";
import HeaderBar from "./HeaderBar";
import { useTheme } from "./ThemeContext";
import { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import { useData } from "./MemberData";
import Cookies from "js-cookie";
import '../../styles/style.css'
import Swal from "sweetalert2";
import axios from "axios";

interface TreasuryLogs{
    type: string;
    amount: number;
    callsign: number;
    reason: string;
    fromCS: number;
    timestamp: string;
}

function ChestPage() {
    const { theme } = useTheme();
    const { getDiscordMemberInfo, getMemberInfo } = useData();
    const [ModalOpen, setOpen] = useState(false);
    const [amount, setAmount] = useState('');
    const [reason, setReason] = useState('');
    const [cFrom, setFrom] = useState('');
    const [modalType, setType] = useState('');
    const [totalVisterie, setVisterie] = useState(0);
    const [visterieLogs, setLogs] = useState<TreasuryLogs[]>([]);

    async function setBani() {
        try {
            const token = Cookies.get("accessToken");
            const response = await axios.get("http://panelmedici.fplayt.ro:5000/visterie/get", { headers: { Authorization: `Bearer ${token}` } });
            if (response && response.data) {
                setVisterie(response.data[0].money || 0);
            } else {
                toast.error("A aparut o eroare! Visteria nu a fost incarcata!");
            }
        } catch (err) {
            console.log(err);
            toast.error("A aparut o eroare! Visteria nu a fost incarcata!");
        }
    
        try {
            const response = await axios.get("http://panelmedici.fplayt.ro:5000/visterie/getHistory");
            if (response) {
                if (response.data) {
                    setLogs(response.data.reverse());
                } else {
                    setLogs([]);
                }
            } else {
                toast.error("A aparut o eroare! Istoricul visteriei nu a fost incarcat!");
                setLogs([]);
            }
        } catch (error) {
            console.log(error);
            toast.error("A aparut o eroare! Istoricul visteriei nu a fost incarcat!");
        }
    }
    

    useEffect(() => {
        setBani()
    }, []);

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '35%',
        height: '55%',
        display: 'flex',
        flexDirection: 'column',
        gap: '2%',
        bgcolor: theme === 'dark' ? '#191919' : 'white',
        boxShadow: 24,
        borderRadius: '.3vw',
        outline: 'none',
        p: 2,
    };

    const handleOpenModal = (tip: string) => {
        setType(tip)
        setOpen(true);
    }
    
    const handleClose = () => {
        setOpen(false);
    }

    function getRomaniaDateTime() {
        const options = { timeZone: "Europe/Bucharest", hour12: false };
        const now = new Date();
    
        const day = now.toLocaleString("en-GB", { ...options, day: "2-digit" });
        const month = now.toLocaleString("en-GB", { ...options, month: "2-digit" });
        const year = now.toLocaleString("en-GB", { ...options, year: "numeric" });
    
        const hours = now.toLocaleString("en-GB", { ...options, hour: "2-digit" });
        const minutes = now.toLocaleString("en-GB", { ...options, minute: "2-digit" });
    
        return `${day}/${month}/${year} - ${hours}:${minutes}`;
    }

    function validateString(input: string | null) {
        if (!input) return false;
    
        if (/[^0-9]/.test(input)) return false;
    
        if (input.startsWith('-')) return false;
    
        if (input.length > 3) return false;
    
        return true;
    }

    const addMoney = async () => {
        if (validateString(cFrom) === false) {
            toast.error("Callsign invalid!");
            return;
        }
        const callsign = getDiscordMemberInfo(Cookies.get("myDiscordID") || '', "callsign");
        handleClose();
        const parsedAmount = Number(amount) || 0;
        const result = await Swal.fire({
            title: `Esti sigur ca vrei sa adaugi suma de ${parsedAmount} din visterie?`,
            text: `Aceasta actiune este ireversibila!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Da, continuă",
            cancelButtonText: "Anulează",
            confirmButtonColor: "#D8630F",
        });
    
        if (!result.isConfirmed) {
            toast.info("Ai anulat acțiunea de adaugare bani din visterie!");
            return;
        } else {
            try {
                let token = Cookies.get("accessToken");
                const response = await axios.post("http://panelmedici.fplayt.ro:5000/visterie/createLog", {
                    type: "ADAUGARE",
                    amount: parsedAmount,
                    callsign: callsign,
                    reason: reason,
                    from_callsign: cFrom,
                    timestamp: getRomaniaDateTime()
                }, { headers: { Authorization: `Bearer ${token}` } });
    
                if (response.statusText === "OK") {
                    try {
                        const updatedMoney = (totalVisterie || 0) + parsedAmount;
                        const updateResponse = await axios.post("http://panelmedici.fplayt.ro:5000/visterie/updateVisterie", {
                            money: updatedMoney,
                            type: "ADAUGARE",
                            full_name: getMemberInfo(callsign, "full_name"),
                            callsign: Number(cFrom),
                            reason: reason,
                            amount: parsedAmount
                        }, { headers: { Authorization: `Bearer ${token}` } });
    
                        if (updateResponse.statusText === "OK") {
                            setBani();
                            handleClose();
                            setAmount("");
                            setReason("");
                            setFrom("");
                            toast.success("Ai adaugat bani in visterie!");
                        }
                    } catch (err) {
                        console.log(err);
                        toast.error("A aparut o eroare! Istoricul visteriei nu s-a incarcat.");
                    }
                }
            } catch (error) {
                if (axios.isAxiosError(error) && error.response && error.response.status === 401) {
                    await handleTokenRefresh();
                    await addMoney();
                } else {
                    toast.error("A aparut o eroare! Banii nu au fost adaugati in visterie");
                }
            }
        }
    };
    
    const removeMoney = async () => {
        if (validateString(cFrom) === false) {
            toast.error("Callsign invalid!");
            return;
        }
        const callsign = getDiscordMemberInfo(Cookies.get("myDiscordID") || '', "callsign");
        handleClose();
        const parsedAmount = Number(amount) || 0;
        const result = await Swal.fire({
            title: `Esti sigur ca vrei sa scoti suma de ${parsedAmount} din visterie?`,
            text: `Aceasta actiune este ireversibila!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Da, continuă",
            cancelButtonText: "Anulează",
            confirmButtonColor: "#D8630F",
        });
    
        if (!result.isConfirmed) {
            toast.info("Ai anulat acțiunea de scoatere bani din visterie!");
            return;
        } else {
            try {
                let token = Cookies.get("accessToken");
                const response = await axios.post("http://panelmedici.fplayt.ro:5000/visterie/createLog", {
                    type: "SCOATERE",
                    amount: parsedAmount,
                    callsign: callsign,
                    reason: reason,
                    from_callsign: cFrom,
                    timestamp: getRomaniaDateTime()
                }, { headers: { Authorization: `Bearer ${token}` } });
    
                if (response.statusText === "OK") {
                    try {
                        const updatedMoney = (totalVisterie || 0) - parsedAmount;
                        const updateResponse = await axios.post("http://panelmedici.fplayt.ro:5000/visterie/updateVisterie", {
                            money: updatedMoney,
                            type: "SCOATERE",
                            full_name: getMemberInfo(callsign, "full_name"),
                            callsign: Number(cFrom),
                            reason: reason,
                            amount: parsedAmount
                        }, { headers: { Authorization: `Bearer ${token}` } });
    
                        if (updateResponse.statusText === "OK") {
                            setBani();
                            handleClose();
                            setAmount("");
                            setReason("");
                            setFrom("");
                            toast.success("Ai scos bani din visterie!");
                        }
                    } catch (err) {
                        console.log(err);
                        toast.error("A aparut o eroare! Istoricul visteriei nu s-a incarcat.");
                    }
                }
            } catch (error) {
                if (axios.isAxiosError(error) && error.response && error.response.status === 401) {
                    await handleTokenRefresh();
                    await removeMoney();
                } else {
                    toast.error("A aparut o eroare! Banii nu au fost scosi din visterie");
                }
            }
        }
    };
    
    const deleteHistory = async () => {
        const result = await Swal.fire({
            title: `Esti sigur ca vrei sa stergi istoricul din visterie?`,
            text: `Aceasta actiune este ireversibila!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Da, continuă",
            cancelButtonText: "Anulează",
            confirmButtonColor: "#D8630F",
        });
    
        let token = Cookies.get("accessToken");
    
        if (!result.isConfirmed) {
            toast.info("Ai anulat acțiunea de stergere istoric!");
            return;
        } else {
            try {
                const response = await axios.post("http://panelmedici.fplayt.ro:5000/visterie/deleteHistory", {}, { headers: { Authorization: `Bearer ${token}` } });
                if (response.statusText === "OK") {
                    toast.success("Istoricul a fost sters!");
                    setLogs([]);
                } else {
                    toast.error("A aparut o eroare! Istoricul nu a fost sters.");
                }
            } catch (error) {
                if (axios.isAxiosError(error) && error.response && error.response.status === 401) {
                    await handleTokenRefresh();
                    await deleteHistory();
                } else {
                    toast.error("A aparut o eroare! Istoricul nu a fost sters.");
                }
            }
        }
    };
    
    const handleTokenRefresh = async () => {
        let refreshToken = Cookies.get("refreshToken");
        if (!refreshToken) {
            toast.error("Nu ai un refresh token valabil!");
            return;
        }
    
        const refreshResponse = await axios.post("http://panelmedici.fplayt.ro:5000/api/refresh-token", { refreshToken: refreshToken });
    
        if (refreshResponse.status === 200) {
            const newAccessToken = refreshResponse.data.accessToken;
            Cookies.set("accessToken", newAccessToken);
        } else {
            toast.error("Refresh token-ul nu este valid!");
        }
    };
    
    return (
        <div className={`${theme} w-full h-full flex flex-col gap-3 box-border`}>
            <HeaderBar currentPage="Visterie"/>
            <div className="w-[98%] h-[84%] flex gap-[2%] flex-col items-center box-border">
                <span className="textBold text-[2vw] text-white">VISTERIE</span>
                <div className="w-[40%] h-[40%] bg-[#00000010] dark:bg-[#ffffff10] border border-[#00000020] dark:border-[#ffffff20] rounded-[.5vw] flex flex-col items-center box-border px-[1%]">
                    <span className="mt-[2%] textMedium text-white text-[1.5vw]">Total bani</span>
                    <span className={`mt-[3%] textExtraBold text-[3vw] ${Number(totalVisterie) > 0 ? "text-[#18c900]" : "text-[#c90000]"} blur-[2vw] hover:blur-0 transition-all`}>{totalVisterie.toLocaleString('de-DE')}$</span>
                    <div className="mt-[5%] w-[75%] h-[25%] flex flex-row items-center justify-between">
                        <div onClick={() => handleOpenModal('add')} className="w-[49%] h-full flex items-center bg-gradient-to-r from-[#19c20e] to-[#3bdb16] justify-center rounded-[.5vw] cursor-pointer">
                            <span className="textSemiBold text-[1.5vw] text-white">ADAUGĂ</span>
                        </div>
                        <div onClick={() => handleOpenModal('rmv')} className="w-[49%] h-full flex items-center bg-gradient-to-r from-[#c20e0e] to-[#f51818] justify-center rounded-[.5vw] cursor-pointer">
                            <span className="textSemiBold text-[1.5vw] text-white">SCOATE</span>
                        </div>
                    </div>
                </div>
                <div className="w-full h-fit flex items-center justify-center gap-[2%]">
                    <span className="textBold text-[2vw] text-white">ISTORIC</span>
                    <div onClick={deleteHistory} className="px-[2%] py-[0.5%] cursor-pointer flex items-center justify-center rounded-[.5vw] bg-gradient-to-b from-[#c20e0e] to-[#f51818]">
                        <span className="textMedium text-white text-[1vw]">Sterge Istoric</span>
                    </div>
                </div>
                <div className="w-[60%] h-[40%] flex flex-col items-center justify-center box-border bg-[rgba(255,255,255,0.61)] dark:bg-[#605D5D61] gap-[1%] backdrop-blur-[32px] rounded-[1vw]">
                    <div className="bg-white dark:bg-[#323232] w-[98%] h-[93%] rounded-xl flex flex-col overflow-y-scroll">
                        {visterieLogs.map((data, index) => (
                            <div key={index} className="w-full min-h-[18%] flex items-center gap-[1%] box-border pl-[1%] pr-[1%] border-b-[1px] border-[#D0D0D0]">
                                <span className={`textSemiBold w-fit text-center ${data.type === "ADAUGARE" ? 'text-[#19c20e]' : 'text-red-500'} text-[0.9vw]`}>{data.type}</span>
                                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                                <span className="textSemiBold w-fit text-center text-black dark:text-white text-[0.9vw]">{data.amount.toLocaleString('de-DE')}$</span>
                                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                                <span className="textSemiBold w-fit text-center text-black dark:text-white text-[0.9vw]">[M-{String(data.callsign).padStart(3, '0')}]</span>
                                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                                <span className="textSemiBold w-fit text-center text-black dark:text-white text-[0.9vw]">{data.reason}</span>
                                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                                <span className="textSemiBold w-fit text-center text-black dark:text-white text-[0.9vw]">M-{String(data.fromCS).padStart(3, '0')}</span>
                                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                                <span className="textSemiBold w-fit text-center text-[#808080] text-[0.8vw]">{data.timestamp}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={ModalOpen}
                onClose={handleClose}
                closeAfterTransition
                slots={{ backdrop: Backdrop }}
                slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                }}
            >
                <Fade in={ModalOpen}>
                <Box sx={style} className="flex flex-col items-center">
                    {modalType === "add" ? (
                        <span className="text-black dark:text-white textSemiBold text-[1vw] w-full text-center">ADAUGARE BANI VISTERIE</span>
                    ): (
                        <span className="text-black dark:text-white textSemiBold text-[1vw] w-full text-center">SCOATERE BANI VISTERIE</span>
                    )}
                    <input
                        onChange={e => setAmount(e.target.value)}
                        placeholder="Suma"
                        type="number"
                        className="w-[60%] h-[14%] mt-[3%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
                    />
                    <input
                        onChange={e => setReason(e.target.value)}
                        placeholder="Motiv"
                        type="text"
                        className="w-[60%] h-[14%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
                    />
                    {modalType === "add" ? (
                        <input
                            onChange={e => setFrom(e.target.value)}
                            placeholder="Bani primiti de la (callsign)"
                            type="text"
                            className="w-[60%] h-[14%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
                        />
                    ) : (
                        <input
                            onChange={e => setFrom(e.target.value)}
                            placeholder="Bani dati lui (callsign)"
                            type="text"
                            className="w-[60%] h-[14%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
                        />
                    )}
                    {modalType === "add" ? (
                        <div onClick={addMoney} className="cursor-pointer mt-[10%] w-[70%] h-[14%] flex items-center justify-center bg-gradient-to-b from-[#D8630F] to-[rgba(245,147,24,0.75)] shadow-[0_2px_0_rgba(0,0,0,0.25)] rounded-[40px]">
                            <span className="text-white textBold text-[1vw]">ADAUGA</span>
                        </div>
                    ) : (
                        <div onClick={removeMoney} className="cursor-pointer mt-[10%] w-[70%] h-[14%] flex items-center justify-center bg-gradient-to-b from-[#D8630F] to-[rgba(245,147,24,0.75)] shadow-[0_2px_0_rgba(0,0,0,0.25)] rounded-[40px]">
                            <span className="text-white textBold text-[1vw]">SCOATE</span>
                        </div>
                    )}
                </Box>
                </Fade>
            </Modal>
            <ToastContainer />
        </div>
    )
}

export default ChestPage;